import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useChartData } from '../../context/ChartContext';
import Label from '../../elements/Label';
import FormikForm from '../../elements/formik/FormikForm';
import FormikInput from '../../elements/formik/FormikInput';
function FromToFilter({ onSubmit }, ref) {
    const { xDomain } = useChartData();
    return (_jsx(FormikForm, { ref: ref, initialValues: { from: xDomain[0], to: xDomain[1] }, onSubmit: onSubmit, children: _jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: "Range :" }), _jsx(Label, { title: "From :", children: _jsx(FormikInput, { name: "from", type: "number" }) }), _jsx(Label, { title: "To :", children: _jsx(FormikInput, { name: "to", type: "number" }) })] }) }));
}
export default forwardRef(FromToFilter);
